module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "finance_calculator",
      "dark": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "light": ""
    }
  }, [_c('v-card-text', {
    staticClass: "subheading orange lighten-3 mb-5"
  }, [_c('v-icon', {
    staticClass: "mr-3",
    attrs: {
      "medium": "",
      "light": ""
    }
  }, [_vm._v("info")]), _vm._v(" Once you have decided on the perfect vehicle, we'll work with you to arrange your financing. We have a variety of terms to suit your needs. Enter your email address and phone\n                    number to get pre-approved before you buy, putting more negotiating power in your hands.\n            ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "lg2": ""
    }
  }, [_c('v-subheader', [_vm._v("Price of Vehicle")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-slider', {
    attrs: {
      "dark": "",
      "tabindex": "0",
      "max": 500000,
      "min": 1
    },
    model: {
      value: (_vm.vehicle_price),
      callback: function($$v) {
        _vm.vehicle_price = $$v
      },
      expression: "vehicle_price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "max": "500000",
      "min": 1,
      "hint": "Typing is enabled",
      "persistent-hint": true,
      "prefix": "$"
    },
    model: {
      value: (_vm.vehicle_price),
      callback: function($$v) {
        _vm.vehicle_price = $$v
      },
      expression: "vehicle_price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "lg2": ""
    }
  }, [_c('v-subheader', [_vm._v("Downpayment")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-slider', {
    attrs: {
      "tabindex": "1",
      "max": 99,
      "min": 0
    },
    model: {
      value: (_vm.down_payment),
      callback: function($$v) {
        _vm.down_payment = $$v
      },
      expression: "down_payment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "max": 99,
      "min": 10,
      "hint": "Typing is enabled",
      "persistent-hint": true,
      "suffix": "%"
    },
    model: {
      value: (_vm.down_payment),
      callback: function($$v) {
        _vm.down_payment = $$v
      },
      expression: "down_payment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "lg2": ""
    }
  }, [_c('v-subheader', [_vm._v("Payment term")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-slider', {
    attrs: {
      "max": 7,
      "min": 4
    },
    model: {
      value: (_vm.loan_duration),
      callback: function($$v) {
        _vm.loan_duration = $$v
      },
      expression: "loan_duration"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "max": 7,
      "min": 1,
      "hint": "Typing is enabled",
      "persistent-hint": true,
      "suffix": "Years"
    },
    model: {
      value: (_vm.loan_duration),
      callback: function($$v) {
        _vm.loan_duration = $$v
      },
      expression: "loan_duration"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.calculation_valid),
      expression: "calculation_valid"
    }],
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "md9": "",
      "lg9": ""
    }
  }, [_c('v-card', {
    staticClass: "grey darken-2"
  }, [_c('v-card-text', [_c('v-subheader', {
    staticClass: "title"
  }, [_vm._v("Your total amount for financing is")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-card', {
    staticClass: "grey darken-2"
  }, [_c('v-card-text', [_c('v-subheader', {
    staticClass: "headline"
  }, [_vm._v("$ " + _vm._s(_vm.calc_total_financed))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "md9": "",
      "lg9": "",
      "mt-2": ""
    }
  }, [_c('v-card', {
    staticClass: "grey darken-2"
  }, [_c('v-card-text', [_c('v-subheader', {
    staticClass: "title"
  }, [_vm._v("Your total monthly payment is")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "md3": "",
      "lg3": "",
      "mt-2": ""
    }
  }, [_c('v-card', {
    staticClass: "grey darken-2"
  }, [_c('v-card-text', [_c('v-subheader', {
    staticClass: "headline green--text text--lighten-1"
  }, [_vm._v("$ " + _vm._s(_vm.calc_monthly_paymt))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs-12": ""
    }
  }, [_c('modal-form', {
    attrs: {
      "vehicle_price": _vm.vehicle_price,
      "down_payment": _vm.dpValue,
      "loan_duration": _vm.loan_duration,
      "interest_rate": _vm.interest_rate,
      "monthly_payment": _vm.monthly_payment
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.calculation_valid),
      expression: "!calculation_valid"
    }],
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-subheader', {
    staticClass: "title red--text text--accent-3"
  }, [_vm._v("The data you entered is not valid.")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bb10aad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 39
// module chunks = 1